<template>
  <div class="app-container">
    <div
      v-if="artisan != null"
      class="modal fade bd-example-modal-lg"
      id="viewLocation"
      tabindex="-1"
      role="dialog"
      aria-labelledby="viewMoreLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{artisan.name}} Locations</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container mb-5">
              <select v-model="selectedLocation" class="form-control">
                <option value>Select Location</option>
                <option
                  v-for="(location,index) in unassignedLocation"
                  :key="index"
                  :value="location.id"
                >{{location.name}}</option>
              </select>
              <button class="btn btn-primary" @click="addLocation()">Add</button>
            </div>
            <div class="container mb-5">
              <ol class="list-group">
                <li
                  class="list-group-item"
                  v-for="(location,index) in artisan.locations"
                  :key="index"
                >
                  <div class="row">
                    <span class="test-dark col-6">{{location.location.name}}</span>
                    <button
                      class="btn btn-danger"
                      @click="removeLocation(location.location.id,index)"
                    >remove</button>
                  </div>
                </li>
              </ol>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <!-- begin app-main -->
    <div class="app-main" id="main">
      <!-- begin container-fluid -->
      <div class="container-fluid">
        <!-- begin row -->
        <div class="row">
          <div class="col-md-12 m-b-30">
            <!-- begin page title -->
            <div class="d-block d-sm-flex flex-nowrap align-items-center">
              <div class="page-title mb-2 mb-sm-0">
                <h1>Artisans</h1>
              </div>
              <div class="ml-auto d-flex align-items-center">
                <nav>
                  <ol class="breadcrumb p-0 m-b-0">
                    <li class="breadcrumb-item">
                      <a >
                        <i class="ti ti-home"></i>
                      </a>
                    </li>
                    <li class="breadcrumb-item">Artisans</li>
                  </ol>
                </nav>
              </div>
            </div>
            <!-- end page title -->
          </div>
        </div>
        <!-- end row -->
        <div
          class="modal fade"
          id="createModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="createModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Create Artisan</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <label>Image</label>
                    <input
                      type="file"
                      id="myFile"
                      @click="encodeFile"
                      @change="encodeFile"
                      class="form-control"
                    />
                  </div>

                  <div class="form-group">
                    <label>Name</label>
                    <input type="text" class="form-control" v-model="editArtisan.name" />
                  </div>

                  <div class="form-group">
                    <label>Service Fee</label>
                    <input type="text" class="form-control" v-model="editArtisan.service_fee" />
                  </div>

                  <div class="form-group">
                    <label>Opening Hours</label>
                    <input type="text" class="form-control" v-model="editArtisan.opening_hours" />
                  </div>

                  <div class="form-group">
                    <label>Description</label>
                    <input type="text" class="form-control" v-model="editArtisan.description" />
                  </div>

                  <div class="form-group">
                    <label>Email</label>
                    <input type="email" class="form-control" v-model="editArtisan.email" />
                  </div>

                  <div class="form-group">
                    <label>Phone Number</label>
                    <input type="text" class="form-control" v-model="editArtisan.phone_number" />
                  </div>

                  <div class="form-group">
                    <label>Address</label>
                    <input type="text" class="form-control" v-model="editArtisan.address" />
                  </div>

                  <div class="form-group">
                    <label>Link</label>
                    <input type="text" class="form-control" v-model="editArtisan.link" />
                  </div>

                  <div class="form-row">
                    <input
                      type="checkbox"
                      class="form-check mr-2"
                      v-model="editArtisan.requires_location"
                    />
                    <label class="form-check-label" for="exampleCheck1">Requires Location</label>
                  </div>

                  <div class="form-group">
                    <label>Service</label>
                    <select class="form-control" v-model="editArtisan.service_id">
                      <option>Select Service</option>
                      <option
                        :value="service.id"
                        v-for="(service,index) in services"
                        :key="index"
                        :selected="(service.id == editArtisan.service_id)? 'selected' : ''"
                      >{{service.name}}</option>
                    </select>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button
                  type="button"
                  @click="createArtisan();"
                  class="btn btn-primary"
                  data-dismiss="modal"
                >Save changes</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal -->
        <div
          class="modal fade"
          id="editModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="editModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Edit Service</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <label>Image</label>
                    <input
                      type="file"
                      id="myFile"
                      @click="encodeFile"
                      @change="encodeFile"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group">
                    <label>Name</label>
                    <input type="text" class="form-control" v-model="editArtisan.name" />
                  </div>

                  <div class="form-group">
                    <label>Service Fee</label>
                    <input type="text" class="form-control" v-model="editArtisan.service_fee" />
                  </div>

                  <div class="form-group">
                    <label>Opening Hours</label>
                    <input type="text" class="form-control" v-model="editArtisan.opening_hours" />
                  </div>

                  <div class="form-group">
                    <label>Description</label>
                    <input type="text" class="form-control" v-model="editArtisan.description" />
                  </div>

                  <div class="form-group">
                    <label>Email</label>
                    <input type="email" class="form-control" v-model="editArtisan.email" />
                  </div>

                  <div class="form-group">
                    <label>Phone Number</label>
                    <input type="text" class="form-control" v-model="editArtisan.phone_number" />
                  </div>

                  <div class="form-group">
                    <label>Address</label>
                    <input type="text" class="form-control" v-model="editArtisan.address" />
                  </div>

                  <div class="form-group">
                    <label>Link</label>
                    <input type="text" class="form-control" v-model="editArtisan.link" />
                  </div>

                  <div class="form-row">
                    <input
                      type="checkbox"
                      class="form-check mr-2"
                      v-model="editArtisan.requires_location"
                    />
                    <label class="form-check-label" for="exampleCheck1">Requires Location</label>
                  </div>

                  <div class="form-group">
                    <label>Service</label>
                    <select class="form-control" v-model="editArtisan.service_id">
                      <option>Select Service</option>
                      <option
                        :value="service.id"
                        v-for="(service,index) in services"
                        :key="index"
                        :selected="(service.id == editArtisan.service_id)? 'selected' : ''"
                      >{{service.name}}</option>
                    </select>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button
                  type="button"
                  @click="updateArtisan();"
                  class="btn btn-primary"
                  data-dismiss="modal"
                >Save changes</button>
              </div>
            </div>
          </div>
        </div>
        <!-- begin row -->
        <div class="row">
          <div class="col-lg-12">
            <Loader v-if="$store.getters.isLoading" />
            <div v-else class="card card-statistics">
              <div class="card-body">
                <Loader v-if="$store.getters.isLoading" />
                <div v-else class="export-table-wrapper table-responsive">
                  <div class="export-buttons m-b-20 row">
                    <a
                      href="#"
                      id="exportExcel"
                      class="btn btn-primary col-2"
                      @click.prevent="editArtisan = {}"
                      data-toggle="modal"
                      data-target="#createModal"
                    >Create Artisan</a>
                    <div class="col-1"></div>
                     <select
                      v-model="serviceId"
                      @change="getArtisans()"
                      class="form-control col-2"
                    >
                      <option value="all">All Services</option>
                      <option
                        v-for="(service,index) in services"
                        :key="index"
                        :value="service.id"
                      >{{ service.name | capitalize }}</option>
                    </select>

                    <div class="col-3">
                      <input
                        type="text"
                        v-model="keyword"
                        @keyup="searchArtisans()"
                        placeholder="search"
                        class="form-control"
                      />
                      <div
                        v-if="interval != null"
                        class="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>

                  <table id="export-table" class="table table-bordered">
                    <thead class="thead-light">
                      <tr>
                        <th>Image</th>
                        <th>Name</th>
                        <th>Email</th>

                        <th>Service Fee</th>
                        <th>Service</th>
                        <th>Requires Location</th>
                        <th></th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <span v-if="services.length < 1">No Service Found</span>
                      <tr v-for="(artisan,index) in artisans" :key="index">
                        <td>
                          <img
                            :src="artisan.image"
                            class="profile-image"
                            style="width: 50px; height: 50px;"
                            alt="LOGO"
                          />
                        </td>
                        <td>{{artisan.name}}</td>
                        <td>{{artisan.email}}</td>
                        <td>{{artisan.service_fee | currency }}</td>

                        <td>{{artisan.service.name}}</td>
                        <td>{{artisan.requires_location? "Yes" : "No"}}</td>

                        <td>
                          <button
                            class="btn btn-primary"
                            data-toggle="modal"
                            data-target="#viewLocation"
                            @click="loadOrder(artisan,index)"
                            :disabled="(artisan.requires_location)? false :true"
                          >View Locations</button>
                        </td>
                        <td>
                          <button
                            class="btn btn-secondary mr-5"
                            @click.prevent="editing = true; prepEdit(artisan)"
                            data-toggle="modal"
                            data-target="#editModal"
                          >&#9998;</button>
                        </td>

                        <td>
                          <button
                            class="btn btn-danger"
                            @click.prevent="deleteArtisan(artisan.id,index)"
                          >🗑</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <sliding-pagination
                    v-if="artisans.length > 0"
                    :current="currentPage"
                    :total="totalPages"
                    @page-change="pageChangeHandler"
                  ></sliding-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end container-fluid -->
    </div>
    <!-- end app-main -->
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Loader from "../../components/Loader.vue";
export default {
  data() {
    return {
      services: [],
      editing: false,
      state: "all",
      currentPage: 1,
      editArtisan: {},
      artisans: [],
      totalPages: 1,
      keyword: "",
      artisan: null,
      index: null,
      unassignedLocation: [],
      selectedLocation: "",
      interval: null,
      serviceId: "all"
    };
  },
  components: {
    Loader
  },
  mounted() {
    this.getServices();
    this.getArtisans();
  },
  methods: {
    searchArtisans() {
      if (this.interval != null) {
        clearTimeout(this.interval);
        this.interval = null;
      }
      this.interval = setTimeout(this.querySearch, 2000);
    },
    querySearch() {
      clearTimeout(this.interval);
      this.interval = null;
      if (this.keyword.length < 1) {
        this.getOrders();
        return;
      }

      fetch(
        this.$store.getters.baseURL +
          "services/artisans/" +
          encodeURI(this.keyword) +
          "/search?page=" +
          this.currentPage,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.getToken
          }
        }
      )
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.artisans = result.data.data;
            this.currentPage = result.data.current_page;
            this.totalPages = result.data.last_page;
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
        });
    },
    loadOrder(artisan, index) {
      this.artisan = { ...artisan };
      this.index = index;

      this.getUnassignedLocations(artisan.id);
    },
    pageChangeHandler(page) {
      this.currentPage = page;
      if (this.keyword.length < 1) this.getArtisans();
      else this.querySearch();
    },
    encodeFile(e) {
      let file = e.target.files[0];
      if (!file) return;

      let reader = new FileReader();
      reader.onloadend = () => {
        this.editArtisan.image = reader.result;
      };
      reader.readAsDataURL(file);
    },
    prepEdit(service) {
      this.editArtisan = { ...service };
      this.editArtisan.image = null;
    },
    getServices() {
      this.$store.commit("setLoading", true);
      fetch(this.$store.getters.baseURL + "services/services/all/all", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$store.getters.getToken
        }
      })
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.services = result.data.data;
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },
    getArtisans() {
      this.$store.commit("setLoading", true);
      fetch(
        this.$store.getters.baseURL +
          `services/artisans/${this.serviceId}/all?page=` +
          this.currentPage,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.getToken
          }
        }
      )
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.artisans = result.data.data;
            this.currentPage = result.data.current_page;
            this.totalPages = result.data.last_page;
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },
    deleteArtisan(id, index) {
      const link =
        this.$store.getters.baseURL + "services/artisans/" + id + "/destroy";

      Swal.queue([
        {
          icon: "warning",
          title: "Delete artisan?",
          confirmButtonText: "Confirm Delete!",
          showCancelButton: true,
          text: "This action is irreversible and can break the system",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            return fetch(link, {
              method: "DELETE",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + this.$store.getters.getToken
              }
            })
              .then(response => response.json())
              .then(result => {
                if (result.status) {
                  Swal.insertQueueStep({
                    icon: "success",
                    title: result.message
                  });
                  this.artisans.splice(index, 1);
                } else {
                  Swal.insertQueueStep({
                    icon: "error",
                    title: result.message
                  });
                }
              })
              .catch(() => {
                Swal.insertQueueStep({
                  icon: "error",
                  title: "Some thing went wrong",
                  text: "Check your internet connection"
                });
              });
          }
        }
      ]);
    },

    updateArtisan() {
      this.editArtisan.requires_location = Number(
        this.editArtisan.requires_location
      );
      this.$store.commit("setLoading", true);
      fetch(
        this.$store.getters.baseURL +
          "services/artisans/" +
          this.editArtisan.id +
          "/update",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.getToken
          },
          body: JSON.stringify(this.editArtisan)
        }
      )
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            let artisanIndex = this.artisans.findIndex(artisan => {
              if (artisan.id == this.editArtisan.id) return true;
            });
            this.artisans[artisanIndex] = result.data;
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },

    createArtisan() {
      this.editArtisan.requires_location = Number(
        this.editArtisan.requires_location
      );
      this.$store.commit("setLoading", true);
      fetch(this.$store.getters.baseURL + "services/artisans/create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$store.getters.getToken
        },
        body: JSON.stringify(this.editArtisan)
      })
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.artisans = [result.data, ...this.artisans];
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },
    getUnassignedLocations(id) {
      console.log(this.artisan);
      this.$store.commit("setLoading", true);
      fetch(
        this.$store.getters.baseURL +
          `services/artisans/${id}/unassigned_location`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.getToken
          },
          method: "PUT"
        }
      )
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.unassignedLocation = result.data;
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },
    addLocation() {
      this.$store.commit("setLoading", true);

      fetch(
        this.$store.getters.baseURL +
          `services/artisans/${this.artisan.id}/add_location`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.getToken
          },
          method: "PUT",
          body: JSON.stringify({ location_id: this.selectedLocation })
        }
      )
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.artisan.locations = [result.data, ...this.artisan.locations];
            let unAssignedIndex = this.unassignedLocation.findIndex(
              location => {
                if (location.id == result.data.location.id) return true;
              }
            );
            this.unassignedLocation.splice(unAssignedIndex, 1);
            this.selectedLocation = "";
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },
    removeLocation(locationId, index) {
      this.$store.commit("setLoading", true);

      fetch(
        this.$store.getters.baseURL +
          `services/artisans/${this.artisan.id}/remove_location`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.getToken
          },
          method: "PUT",
          body: JSON.stringify({ location_id: locationId })
        }
      )
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.unassignedLocation.push(
              this.artisan.locations[index].location
            );
            this.artisan.locations.splice(index, 1);
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    }
  }
};
</script>

<style scoped></style>
